/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// Afterpay styles and content manipulation
(function () {
  function applyAfterpayStyles() {
    const placement = document.querySelector('square-placement');
    if (!placement || !placement.shadowRoot) return;

    const shadow = placement.shadowRoot;

    // Prevent duplicate injection
    if (!shadow.querySelector('#afterpay-custom-style')) {
      const style = document.createElement('style');
      style.id = 'afterpay-custom-style';
      style.textContent = `
        .afterpay-paragraph {
          line-height: 1.5;
        }
        .afterpay-paragraph {
          --messaging-font-size: 15.12px;
        }
        .afterpay-logo.brand-afterpay {
          --logo-badge-width: 82px;
          vertical-align: middle;
        }

        @media (max-width: 1000px) {
          .afterpay-main-text {
            display: block;
            line-height: 1;
          }
        }
      `;
      shadow.appendChild(style);
    }

    // Rewrite copy to: "4 x $XX.XX with "
    const text = shadow.querySelector('.afterpay-main-text');
    if (text && !text.dataset.modified) {
      const amount = text.querySelector('strong')?.textContent?.trim();
      if (amount) {
        text.textContent = `4 x ${amount} with `;
        text.dataset.modified = 'true';
      }
    }
  }

  // Initial run
  applyAfterpayStyles();

  // Observe re-renders (Afterpay + Shopify)
  const observer = new MutationObserver(applyAfterpayStyles);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// PDP selected color media filter:
// Shows only gallery media whose filename or alt text matches the selected color option.
(function () {
  const selectors = {
    productInfo: 'product-info[data-filter-media-by-color="true"]',
    slide: '[data-product-single-media-wrapper]',
    slider: '[data-product-single-media-slider]',
    thumbnails: '[data-product-single-media-thumbs]',
    thumbnail: '.product-single__thumbnail',
    selectedVariant: 'variant-selects [data-selected-variant]',
  };

  const classes = {
    hiddenSlide: 'product-gallery__media-slide--color-hidden',
    hiddenThumbnail: 'product-single__thumbnail--color-hidden',
  };

  const productMediaState = new WeakMap();

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/%20/g, ' ')
      .replace(/[^a-z0-9]+/g, '');
  }

  function getCurrentVariant(productInfo) {
    const variantScript = productInfo.querySelector(selectors.selectedVariant);
    if (!variantScript?.textContent) return null;

    try {
      return JSON.parse(variantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function getColorOptionIndex(productInfo) {
    const colorInput = productInfo.querySelector('input[name^="options["][name*="Color" i], input[name^="options["][name*="Colour" i], select[name^="options["][name*="Color" i], select[name^="options["][name*="Colour" i]');
    const optionName = colorInput?.getAttribute('name') || '';
    const optionLabel = optionName.match(/options\[(.+)\]/)?.[1] || '';
    const optionInputs = Array.from(productInfo.querySelectorAll('[name^="options["]'));
    const optionNames = [...new Set(optionInputs.map((input) => input.getAttribute('name')).filter(Boolean))];
    const optionIndex = optionNames.findIndex((name) => name.includes(`[${optionLabel}]`));

    return optionIndex >= 0 ? optionIndex : -1;
  }

  function getSelectedColor(productInfo) {
    const colorInput = productInfo.querySelector('input[name^="options["][name*="Color" i]:checked, input[name^="options["][name*="Colour" i]:checked');
    if (colorInput?.value) return colorInput.value;

    const colorSelect = productInfo.querySelector('select[name^="options["][name*="Color" i], select[name^="options["][name*="Colour" i]');
    if (colorSelect?.value) return colorSelect.value;

    const currentVariant = getCurrentVariant(productInfo);
    const colorIndex = getColorOptionIndex(productInfo);

    return colorIndex >= 0 ? currentVariant?.options?.[colorIndex] : '';
  }

  function getSlideImage(slide) {
    return slide.querySelector('img[data-product-image], img');
  }

  function slideMatchesColor(slide, colorKey) {
    const image = getSlideImage(slide);
    if (!image) return false;

    const sourceText = normalize([image.currentSrc, image.src, image.getAttribute('src'), image.getAttribute('srcset')].filter(Boolean).join(' '));
    if (sourceText.includes(colorKey)) return true;

    return normalize(image.getAttribute('alt')).includes(colorKey);
  }

  function syncThumbnails(productInfo, visibleMediaIds) {
    productInfo.querySelectorAll(selectors.thumbnail).forEach((thumbnail) => {
      const mediaId = thumbnail.dataset.id;
      const shouldShow = !mediaId || visibleMediaIds.has(mediaId);

      thumbnail.classList.toggle(classes.hiddenThumbnail, !shouldShow);
    });
  }

  function getProductMediaState(productInfo) {
    if (!productMediaState.has(productInfo)) {
      productMediaState.set(productInfo, {
        slider: productInfo.querySelector(selectors.slider),
        thumbnails: productInfo.querySelector(selectors.thumbnails),
        slides: Array.from(productInfo.querySelectorAll(selectors.slide)),
        thumbnailItems: Array.from(productInfo.querySelectorAll(selectors.thumbnail)),
      });
    }

    return productMediaState.get(productInfo);
  }

  function restoreProductMedia(productInfo) {
    const state = getProductMediaState(productInfo);
    const { flkty, flktyNav } = getFlickityInstances(state);
    const slideContainer = flkty?.isActive ? flkty.slider : state.slider;
    const thumbnailContainer = flktyNav?.isActive ? flktyNav.slider : state.thumbnails;

    state.slides.forEach((slide) => {
      slide.classList.remove(classes.hiddenSlide);
      slideContainer?.appendChild(slide);
    });

    state.thumbnailItems.forEach((thumbnail) => {
      thumbnail.classList.remove(classes.hiddenThumbnail);
      thumbnailContainer?.appendChild(thumbnail);
    });

    return state;
  }

  function getFlickityInstances(state) {
    return {
      flkty: state.slider ? window.theme?.Flickity?.data(state.slider) : null,
      flktyNav: state.thumbnails ? window.theme?.Flickity?.data(state.thumbnails) : null,
    };
  }

  function refreshFlickity(productInfo, state, firstVisibleSlide) {
    const { flkty, flktyNav } = getFlickityInstances(state);
    const slideContainer = flkty?.isActive ? flkty.slider : state.slider;
    const visibleSlides = Array.from(slideContainer?.children || []);
    const firstVisibleIndex = firstVisibleSlide ? visibleSlides.indexOf(firstVisibleSlide) : -1;

    [flkty, flktyNav].forEach((instance) => {
      if (!instance?.isActive) return;

      instance.reloadCells?.();
      instance.resize?.();

      if (firstVisibleIndex >= 0) {
        instance.select(firstVisibleIndex, false, true);
      }
    });

    if (flkty?.isActive && firstVisibleSlide?.dataset.mediaId && typeof productInfo.switchMedia === 'function') {
      productInfo.switchMedia(firstVisibleSlide.dataset.mediaId);
    }
  }

  function filterStaticMedia(productInfo, state, visibleSlides) {
    const visibleMediaIds = new Set();

    state.slides.forEach((slide) => {
      const shouldShow = visibleSlides.includes(slide);
      slide.removeAttribute('style');
      slide.classList.toggle(classes.hiddenSlide, !shouldShow);

      if (shouldShow && slide.dataset.id) {
        visibleMediaIds.add(slide.dataset.id);
      }
    });

    syncThumbnails(productInfo, visibleMediaIds);
  }

  function filterFlickityMedia(productInfo, state, visibleSlides) {
    const visibleMediaIds = new Set(visibleSlides.map((slide) => slide.dataset.id).filter(Boolean));

    state.slides.forEach((slide) => {
      if (!visibleSlides.includes(slide)) slide.remove();
    });

    state.thumbnailItems.forEach((thumbnail) => {
      if (thumbnail.dataset.id && !visibleMediaIds.has(thumbnail.dataset.id)) {
        thumbnail.remove();
      }
    });

    refreshFlickity(productInfo, state, visibleSlides[0]);
  }

  function filterProductMedia(productInfo) {
    if (!productInfo?.matches?.(selectors.productInfo)) return;

    const state = restoreProductMedia(productInfo);
    const { flkty } = getFlickityInstances(state);
    const shouldUseFlickity = productInfo.getAttribute('data-tall-layout') !== 'true' || window.innerWidth < window.theme.sizes.large;
    const isFlickityActive = shouldUseFlickity && Boolean(flkty?.isActive);
    const colorKey = normalize(getSelectedColor(productInfo));
    const slides = state.slides;
    if (!slides.length) return;

    if (!colorKey) {
      refreshFlickity(productInfo, state, slides[0]);
      return;
    }

    const matchingSlides = slides.filter((slide) => slideMatchesColor(slide, colorKey));
    const hasMatches = matchingSlides.length > 0;
    const visibleSlides = hasMatches ? matchingSlides : slides;

    if (isFlickityActive) {
      filterFlickityMedia(productInfo, state, visibleSlides);
    } else {
      filterStaticMedia(productInfo, state, visibleSlides);
    }
  }

  function filterAllProductMedia() {
    document.querySelectorAll(selectors.productInfo).forEach((productInfo) => {
      filterProductMedia(productInfo);
    });
  }

  function scheduleFilterAllProductMedia() {
    requestAnimationFrame(() => {
      requestAnimationFrame(filterAllProductMedia);
    });
  }

  function isColorOptionTarget(target) {
    return Boolean(target?.name?.match(/options\[(Color|Colour)\]/i));
  }

  document.addEventListener('theme:product-info:loaded', (event) => {
    requestAnimationFrame(() => filterProductMedia(event.target));
  });

  document.addEventListener('DOMContentLoaded', () => {
    scheduleFilterAllProductMedia();
  });

  document.addEventListener('theme:resize:width', () => {
    scheduleFilterAllProductMedia();
  });

  // Run ahead of the theme's server-rendered variant update so PDP media changes feel instant.
  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const productInfo = data?.target?.closest?.(selectors.productInfo);
      if (!productInfo || !isColorOptionTarget(data.target)) return;

      requestAnimationFrame(() => filterProductMedia(productInfo));
    });
  }

  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`${selectors.productInfo}[data-section="${data.sectionId}"]`);

      requestAnimationFrame(() => filterProductMedia(productInfo));
    });
  }
})();



// Palo Alto resolves preorder state server-side and re-renders the ATC button HTML on variant changes.
// Observe final button text output and synchronise preorder state + form property atomically.

(function () {
  const observed = new WeakSet();

  function extractEstimatedToShip(textNode) {
    const helper = textNode.querySelector('.button-helper-text');
    if (!helper) return '';

    const text = helper.textContent.replace(/\s+/g, ' ').trim();
    const idx = text.indexOf('Estimated to Ship');
    return idx !== -1 ? text.slice(idx) : '';
  }

  function sync(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;

    const form = submitButton.closest('form');
    if (!form) return;

    const isInventoryPreorder =
      textNode.querySelector('.button-helper-text') &&
      textNode.textContent.includes('Estimated to Ship');

    // 1. ORIGINAL behaviour (unchanged)
    submitButton.classList.toggle(
      'is_inventory_preorder',
      isInventoryPreorder
    );

    // 2. Property sync (same timing, same truth)
    const existing = form.querySelector(
      'input[name="properties[Pre-order]"]'
    );

    if (isInventoryPreorder) {
      const shipText = extractEstimatedToShip(textNode);
      if (!shipText) return; // guard against mid-render churn

      if (!existing) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Pre-order]';
        input.value = shipText;
        form.appendChild(input);
      } else {
        existing.value = shipText;
      }
    } else {
      existing?.remove();
    }
  }

  function init(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;
    if (observed.has(textNode)) return;

    const observer = new MutationObserver(() => {
      sync(productForm);
    });

    observer.observe(textNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // initial run
    sync(productForm);

    observed.add(textNode);
  }

  document.querySelectorAll('product-form').forEach(init);
})();





// Pre-order acceptance modal
// turning off
// (function () {

//   let consentGiven = false;

//   function getEstimateFromButton(button) {
//     const helper = button.querySelector('.button-helper-text');
//     if (!helper) return '';

//     const text = helper.textContent.replace(/\s+/g, ' ').trim();

//     const idx = text.indexOf('Estimated to Ship');
//     return idx !== -1 ? text.slice(idx) : '';
//   }

//   function createPopup() {
//     let popup = document.getElementById('preorder-consent-popup');

//     if (!popup) {
//       popup = document.createElement('div');
//       popup.id = 'preorder-consent-popup';
//       popup.style.display = 'none';

//       popup.innerHTML = `
//         <div class="preorder-overlay"></div>
//         <div class="preorder-modal">

//           <button type="button" class="preorder-close" aria-label="Close">&times;</button>

//           <h3>Please Confirm Your Pre-Order</h3>

//           <p class="preorder-message">
//             This item is a pre-order and will not ship immediately.<br>
//             <span class="preorder-estimate"></span>            
//           </p>


//           <p>
//             <label class="preorder-checkbox">
//               <input type="checkbox" id="preorder-consent-check" />
//               <span class="custom-checkbox"></span>
//               <span class="checkbox-text">
//               I understand this is a pre-order item and it will ship on or after the estimated date above, and I agree to the <a href="https://originalfitwear.com/en-au/pages/pre-order" target="_blank" class="preorder-info-link">
//               pre-order terms
//             </a>.
//               </span>
//             </label>
//           </p>

//           <div class="preorder-buttons">

//             <button type="button"
//               class="btn btn--solid btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-continue"
//               disabled>
//               <hover-button></hover-button>
//               ADD PRE-ORDER TO CART 
//             </button>

//             <button type="button"
//               class="btn btn--outline btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-decline">
//               <hover-button></hover-button>
//               Cancel
//             </button>

//           </div>

//         </div>
//       `;

//       document.body.appendChild(popup);

//       const overlay = popup.querySelector('.preorder-overlay');
//       const closeBtn = popup.querySelector('.preorder-close');
//       const checkbox = popup.querySelector('#preorder-consent-check');
//       const confirmBtn = popup.querySelector('.preorder-continue');
//       const declineBtn = popup.querySelector('.preorder-decline');

//       checkbox.addEventListener('change', function () {
//         confirmBtn.disabled = !this.checked;
//       });

//       overlay.addEventListener('click', closePopup);
//       closeBtn.addEventListener('click', closePopup);
//       declineBtn.addEventListener('click', closePopup);
//     }

//     return popup;
//   }

//   function closePopup() {
//     const popup = document.getElementById('preorder-consent-popup');
//     if (!popup) return;

//     popup.style.display = 'none';
//     consentGiven = false;
//   }

//   function openPopup(button) {

//     consentGiven = false;

//     const popup = createPopup();
//     if (!popup) return;

//     const checkbox = popup.querySelector('#preorder-consent-check');
//     const confirmBtn = popup.querySelector('.preorder-continue');
//     const estimateTarget = popup.querySelector('.preorder-estimate');

//     checkbox.checked = false;
//     confirmBtn.disabled = true;

//     // 🔥 Grab directly from clicked button
//     const estimateText = getEstimateFromButton(button);
//     estimateTarget.textContent = estimateText || '';

//     popup.style.display = 'flex';

//     confirmBtn.onclick = function () {
//       consentGiven = true;
//       popup.style.display = 'none';
//       button.click();
//     };
//   }

//   document.addEventListener('click', function (e) {

//     const button = e.target.closest('button[type="submit"].is_inventory_preorder');
//     if (!button) return;

//     if (consentGiven) {
//       consentGiven = false;
//       return;
//     }

//     e.preventDefault();
//     e.stopImmediatePropagation();

//     openPopup(button);

//   }, true);

// })();

// Inline size picker quick shop mode:
// Shows size options directly on collection product cards and uses the theme cart pipeline.
(function () {
  const selectors = {
    card: '.product-grid-item--inline-size-picker',
    media: '[data-product-media-container]',
    form: '[data-inline-size-form]',
    picker: '[data-inline-size-picker]',
    trigger: '[data-inline-size-trigger]',
    option: '[data-inline-size-option]',
    close: '[data-inline-size-close]',
    variantInput: '[data-inline-size-variant-input]',
    preorderInput: '[data-inline-size-preorder-input]',
    swatchVariant: '[data-swatch-variant]',
  };

  const classes = {
    open: 'product-grid-item--inline-sizes-open',
  };

  // Viewport-width breakpoint (matches the CSS) — drives mobile bottom-sheet
  // vs desktop hover behavior. Switched from (hover: hover) so resizing a
  // desktop browser narrow gives the mobile experience as expected.
  const desktopQuery = window.matchMedia('(min-width: 768px)');
  const inlineSizeAmpDebug = false;
  let ampCartHandoffController = null;

  function isEnabled() {
    return window.theme?.settings?.quickBuy === 'inline_size_picker';
  }

  function isAmpCartDebugEnabled() {
    return inlineSizeAmpDebug;
  }

  // Inline size picker AMP cart handoff debug logging.
  function logAmpCartHandoff(message, detail) {
    if (!isAmpCartDebugEnabled()) return;

    console.log('[Inline size AMP cart]', message, detail || '');
  }

  // Inline size picker AMP cart handoff waits for the theme add-to-cart pipeline before opening AMP.
  function waitForThemeCartAdded() {
    if (ampCartHandoffController) {
      ampCartHandoffController.abort();
    }

    ampCartHandoffController = new AbortController();
    const { signal } = ampCartHandoffController;

    return new Promise((resolve, reject) => {
      signal.addEventListener(
        'abort',
        () => reject(new DOMException('Inline size AMP cart handoff replaced.', 'AbortError')),
        { once: true }
      );

      document.addEventListener('theme:cart:added', resolve, { once: true, signal });
    }).finally(() => {
      if (ampCartHandoffController?.signal === signal) {
        ampCartHandoffController = null;
      }
    });
  }

  // Inline size picker AMP cart handoff uses AMP globals only when the app is available.
  async function openAmpCartAfterThemeAdd(option) {
    logAmpCartHandoff('Waiting for theme:cart:added.', { variantId: option.dataset.variantId });

    await waitForThemeCartAdded();

    if (typeof window.SLIDECART_UPDATE === 'function') {
      logAmpCartHandoff('Refreshing AMP cart.');
      await Promise.resolve(window.SLIDECART_UPDATE());
    } else {
      logAmpCartHandoff('SLIDECART_UPDATE is not available.');
    }

    if (typeof window.SLIDECART_OPEN === 'function') {
      logAmpCartHandoff('Opening AMP cart.');
      window.SLIDECART_OPEN();
    } else {
      logAmpCartHandoff('SLIDECART_OPEN is not available.');
    }
  }

  function isDesktopHover() {
    return desktopQuery.matches;
  }

  function getCard(target) {
    if (!target) return null;
    const direct = target.closest?.(selectors.card);
    if (direct) return direct;
    // Picker may be portaled out to <body> on mobile; follow the back-reference.
    const picker = target.closest?.(selectors.picker);
    return picker?._owningCard || null;
  }

  function getForm(card) {
    return card?._portaledForm || card?.querySelector(selectors.form);
  }

  function getPicker(card) {
    return card?._portaledPicker || card?.querySelector(selectors.picker);
  }

  // Portal the whole form (which contains the picker) out to <body> on open so
  // it escapes every ancestor stacking context. We move the form — not just the
  // picker — because the theme's cartAddEvent listener does
  // `clickedElement.closest('form')` to build FormData. If the option button is
  // outside its form, the cart submit silently fails.
  function portalPicker(card) {
    if (!card) return;
    const form = card.querySelector(selectors.form);
    const picker = card.querySelector(selectors.picker);
    if (!form || form._isPortaled) return;

    form._owningCard = card;
    form._originalParent = form.parentNode;
    form._originalNextSibling = form.nextSibling;
    card._portaledForm = form;
    card._portaledPicker = picker;
    if (picker) picker._owningCard = card;

    ensurePortalContainer().appendChild(form);
    form._isPortaled = true;
    form.classList.add('is-quick-add-form-portaled');
  }

  function restorePicker(card) {
    if (!card) return;
    const form = card._portaledForm;
    if (!form || !form._isPortaled) return;

    if (form._originalParent) {
      form._originalParent.insertBefore(form, form._originalNextSibling || null);
    }
    form._isPortaled = false;
    form._owningCard = null;
    form._originalParent = null;
    form._originalNextSibling = null;
    form.classList.remove('is-quick-add-form-portaled');

    const picker = card._portaledPicker;
    if (picker) picker._owningCard = null;
    delete card._portaledForm;
    delete card._portaledPicker;
  }

  // Singleton container hosting the backdrop AND the portaled form, so quick-add
  // DOM is kept tidy under one root and shares a single high-z-index stacking
  // context that sits above the sticky header / pre-header etc.
  let portalContainerEl = null;
  let backdropEl = null;

  function ensurePortalContainer() {
    if (portalContainerEl) return portalContainerEl;

    portalContainerEl = document.createElement('div');
    portalContainerEl.className = 'quick-add-portal';
    document.body.appendChild(portalContainerEl);

    return portalContainerEl;
  }

  function ensureBackdrop() {
    if (backdropEl) return backdropEl;

    backdropEl = document.createElement('div');
    backdropEl.className = 'quick-add-backdrop';
    backdropEl.setAttribute('aria-hidden', 'true');
    backdropEl.addEventListener('click', () => closeOtherCards(null));

    ensurePortalContainer().appendChild(backdropEl);

    return backdropEl;
  }

  // One function = one truth. Showing the modal turns on the picker's active
  // class AND the body scroll lock atomically. Hiding turns BOTH off. They
  // cannot drift because they're always set together.
  function setPickerActive(picker, isActive) {
    if (!picker) return;
    if (isActive) {
      picker.classList.add('is-quick-add-active');
      ensureBackdrop();
      document.body.classList.add('quick-add-open');
    } else {
      picker.classList.remove('is-quick-add-active');
      document.body.classList.remove('quick-add-open');
    }
  }

  function closeCard(card) {
    if (!card) return;

    const picker = getPicker(card);
    const trigger = card.querySelector(selectors.trigger);

    card.classList.remove(classes.open);
    trigger?.setAttribute('aria-expanded', 'false');

    if (isDesktopHover()) {
      // Desktop: no animation, snap close.
      setPickerActive(picker, false);
      picker?.setAttribute('hidden', '');
      return;
    }

    // Mobile: swap the slide-up animation for the slide-down one, then unmount
    // after it ends. Keeping the form portaled during the close keeps all the
    // bottom-sheet styling (header, options, etc.) applied throughout.
    // setPickerActive(picker, false) releases the lock here — the backdrop
    // fades out in parallel with the slide-down.
    setPickerActive(picker, false);
    picker?.classList.add('is-quick-add-closing');

    const finalize = () => {
      picker?.classList.remove('is-quick-add-closing');
      picker?.setAttribute('hidden', '');
      restorePicker(card);
    };

    if (!picker) {
      finalize();
      return;
    }

    let done = false;
    const onAnimationEnd = (e) => {
      if (e.animationName !== 'quick-add-slide-down' || done) return;
      done = true;
      picker.removeEventListener('animationend', onAnimationEnd);
      finalize();
    };
    picker.addEventListener('animationend', onAnimationEnd);
    // Fallback in case animationend doesn't fire (reduced-motion, etc.).
    setTimeout(() => {
      if (done) return;
      done = true;
      picker.removeEventListener('animationend', onAnimationEnd);
      finalize();
    }, 350);
  }

  function closeOtherCards(activeCard) {
    document.querySelectorAll(`${selectors.card}.${classes.open}`).forEach((card) => {
      if (card !== activeCard) closeCard(card);
    });
  }

  function openCard(card) {
    if (!card) return;

    const trigger = card.querySelector(selectors.trigger);

    closeOtherCards(card);
    card.classList.add(classes.open);

    if (!isDesktopHover()) {
      portalPicker(card);
    }

    // Resolve picker AFTER portaling so we get the moved node.
    const picker = getPicker(card);
    picker?.removeAttribute('hidden');
    trigger?.setAttribute('aria-expanded', 'true');

    if (!isDesktopHover()) {
      // Clear any in-flight closing animation if reopening fast.
      picker?.classList.remove('is-quick-add-closing');
      setPickerActive(picker, true);
    }
  }

  function toggleCard(card) {
    if (!card) return;

    if (card.classList.contains(classes.open)) {
      closeCard(card);
    } else {
      openCard(card);
    }
  }

  function setPreorderInput(form, value) {
    const preorderInput = form?.querySelector(selectors.preorderInput);
    if (!preorderInput) return;

    if (value) {
      preorderInput.value = value;
      preorderInput.disabled = false;
    } else {
      preorderInput.value = '';
      preorderInput.disabled = true;
    }
  }

  function selectContext(card, selectedVariantId) {
    const selectedOption = card.querySelector(`${selectors.option}[data-variant-id="${selectedVariantId}"]`);
    if (!selectedOption) return;

    const contextKey = selectedOption.dataset.contextKey || '';
    const options = card.querySelectorAll(selectors.option);
    let firstVisibleOption = null;

    options.forEach((option) => {
      const isCurrentContext = (option.dataset.contextKey || '') === contextKey;
      option.hidden = !isCurrentContext;

      if (isCurrentContext && !firstVisibleOption) {
        firstVisibleOption = option;
      }
    });

    const variantInput = getForm(card)?.querySelector(selectors.variantInput);
    if (variantInput && firstVisibleOption) {
      variantInput.value = firstVisibleOption.dataset.variantId;
    }
  }

  document.addEventListener('mouseover', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    openCard(card);
  });

  document.addEventListener('mouseout', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    if (!media.contains(event.relatedTarget)) {
      closeCard(card);
    }
  });

  document.addEventListener('focusin', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    openCard(card);
  });

  document.addEventListener('focusout', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    window.setTimeout(() => {
      if (!media.contains(document.activeElement)) {
        closeCard(card);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!isEnabled()) return;

    const swatch = event.target.closest(selectors.swatchVariant);
    if (swatch) {
      const card = getCard(swatch);
      const selectedVariantId = swatch.dataset.swatchVariant || swatch.getAttribute('data-swatch-variant');
      if (card && selectedVariantId) selectContext(card, selectedVariantId);
      return;
    }

    const close = event.target.closest(selectors.close);
    if (close) {
      event.preventDefault();
      closeCard(getCard(close));
      return;
    }

    const trigger = event.target.closest(selectors.trigger);
    if (trigger) {
      event.preventDefault();
      if (!isDesktopHover()) toggleCard(getCard(trigger));
      return;
    }

    const option = event.target.closest(selectors.option);
    if (option) {
      event.preventDefault();

      if (option.disabled || option.getAttribute('aria-disabled') === 'true') return;

      const card = getCard(option);
      const form = getForm(card);
      const variantInput = form?.querySelector(selectors.variantInput);

      if (!card || !form || !variantInput || !option.dataset.variantId) return;

      variantInput.value = option.dataset.variantId;
      setPreorderInput(form, option.dataset.preorderProperty || '');

      // Inline size picker AMP cart handoff starts listening before the add event is dispatched.
      const ampCartHandoff = openAmpCartAfterThemeAdd(option);

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: option,
          },
        })
      );

      ampCartHandoff.catch((error) => {
        if (error.name === 'AbortError') return;

        logAmpCartHandoff('AMP cart handoff failed.', error);
      });

      return;
    }

    if (!isDesktopHover() && !event.target.closest(selectors.picker)) {
      closeOtherCards(null);
    }
  });

  // Resize from mobile → desktop while the bottom-sheet is open would leave the
  // page in a "frozen" state (body scroll locked, form still portaled, picker
  // fixed at the viewport bottom). Snap everything closed on the breakpoint flip.
  desktopQuery.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll(`${selectors.card}.${classes.open}`).forEach((card) => {
      const picker = getPicker(card);
      const trigger = card.querySelector(selectors.trigger);
      card.classList.remove(classes.open);
      setPickerActive(picker, false);
      picker?.classList.remove('is-quick-add-closing');
      picker?.setAttribute('hidden', '');
      trigger?.setAttribute('aria-expanded', 'false');
      restorePicker(card);
    });
  });
})();


// Bypass the theme's GridSwatch click hijack on product-card color swatches.
// The theme calls event.preventDefault() on mouse clicks to swap the card image
// in-place; we want the link to behave like a link. Capture-phase +
// stopImmediatePropagation stops the theme's bubble-phase listener from running,
// so native navigation proceeds.
(function () {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.swatch__link');
    if (!link) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.stopImmediatePropagation();
  }, true);
})();


// Band-aid for AMP Slide Cart's scroll-lock library leaving body locked after
// the cart drawer closes. Captured evidence (see .issue-cart-drawer.txt):
//
//   initial body:                                no inline style, no saved-* attrs
//   cart drawer open: style="overflow:hidden; padding-right:0px;"  + 6 data-scroll-lock-* attrs
//   cart drawer closed: style="overflow:hidden;"  +  data-scroll-lock-saved-overflow-y-property="hidden"
//
// On close the library partially cleans up but "restores" body.overflow to
// "hidden" (a wrongly-saved original state). We clear BOTH the stuck inline
// style AND the library's saved-state attributes so the next open starts clean.
//
// Gated on no real popup being shown so we never override a legitimate lock:
//   - our own quick-add modal (body.quick-add-open)
//   - the theme's <html data-scroll-locked> attribute
//   - any visible [role=dialog][aria-modal=true] element
//
// 150ms delay after click gives the drawer's own close logic a chance first.
(function () {
  // Body classes the theme uses to mark a drawer/popup as truly open. Sourced
  // from theme.dev.js. We avoid generic [role=dialog][aria-modal=true] checks
  // because the theme leaves "ready but hidden" modals in the DOM (search
  // popdown is display:block/visible/opacity:1 even when not actually shown).
  const POPUP_OPEN_CLASSES = [
    'quick-add-open',           // ours
    'js-drawer-open',           // nav drawer
    'js-drawer-open-cart',      // cart drawer (SlideCart)
    'js-quick-view-visible',    // quick view popup
    'js-quick-view-from-cart',
    'search-opened',
  ];

  // NOTE: do NOT check <html data-scroll-locked> here. The same buggy
  // scroll-lock library leaves it stale after cart drawer close, so using it
  // as a gate would defeat the entire band-aid. Body classes (js-drawer-open*,
  // search-opened, etc.) are the only reliable "is something genuinely open"
  // signals — the theme removes them synchronously on close.
  function isAnyModalShown() {
    for (let i = 0; i < POPUP_OPEN_CLASSES.length; i++) {
      if (document.body.classList.contains(POPUP_OPEN_CLASSES[i])) return true;
    }
    return false;
  }

  function clearStuckBodyLock() {
    if (isAnyModalShown()) return;
    const body = document.body;
    const html = document.documentElement;
    if (body.style.overflow === 'hidden') body.style.overflow = '';
    if (body.style.paddingRight) body.style.paddingRight = '';
    // Wipe the scroll-lock library's saved-state attributes so the NEXT open
    // doesn't try to "restore" overflow:hidden from a wrongly-saved value.
    body.removeAttribute('data-scroll-lock-saved-overflow-y-property');
    body.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
    body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
    // Also wipe the stale <html data-scroll-locked> if no popup is open.
    if (html.hasAttribute('data-scroll-locked')) {
      html.removeAttribute('data-scroll-locked');
    }
  }

  document.addEventListener('click', function () {
    setTimeout(clearStuckBodyLock, 150);
  });
})();

